import React from "react";
import "./ALL3DBenefits.scss";
import { Row, Col, Layout } from "antd";
const { Content } = Layout;

const benefits = [
    {
        'icon': '/smb/lightning.svg',
        'title': 'Fast and Efficient',
        'desc': 'Reduce weeks of work down to hours and even minutes'
    },
    {
        'icon': '/smb/tabler_pig-money.svg',
        'title': 'Affordable',
        'desc': 'Cheaper than traditional photo shoots or hiring 3D artists'
    },
    {
        'icon': '/smb/double.png',
        'title': 'Scalable',
        'desc': 'Easily create and manage ecommerce assets at scale'
    },
    {
        'icon': '/smb/up.svg',
        'title': '2x Conversion Rate',
        'desc': 'See an increase in your conversion rates on Amazon'
    }
]
const ALL3DBenefits = () => {

    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    );
}

const WebVersion = () => {
    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid justify-in-center benefits-section">
                <Col span={24} className="justify-in-center text-center">
                    <p className="manrope f-16 lh-24 w-700 black-085">ALL3D Benefits</p>
                </Col>
                <Col span={24} className="justify-in-center text-center">
                    <h3 className="manrope f-30 lh-40 w-600 black-085 mb-64">Save time and money while increasing sales. It’s a win-win.</h3>
                </Col>
                {benefits.map((benefit) => (
                    <Col span={6} className="justify-in-center direction-flex coll pd-16">
                        <img src={benefit.icon} className="mb-16" />
                        <p className="manrope f-20 w-700 lh-28 black-085 mb-8 text-center">{benefit.title}</p>
                        <p className="manrope f-16 w-400 lh-24 black-085 text-center">{benefit.desc}</p>
                    </Col>

                ))}
            </Row>
        </Content>
    );
}

const MobileVersion = () => {
    return (
        <Content className="d-lg-none">
            <Row className="container-fluid justify-in-center benefits-section">
                <Col span={24} className="justify-in-center text-center">
                    <p className="manrope f-16 lh-24 w-700 black-085 mb-16">ALL3D Benefits</p>
                </Col>
                <Col span={24} className="justify-in-center text-center">
                    <h3 className="manrope f-24 lh-32 w-600 black-085 mb-64 justify-in-center text-center">Save time and money while increasing sales. It’s a win-win.</h3>
                </Col>
                {benefits.map((benefit) => (
                    <Col span={24} className="justify-in-center direction-flex coll pd-16">
                        <img src={benefit.icon} className="mb-16" />
                        <p className="manrope f-20 w-700 lh-28 black-085 mb-8 text-center">{benefit.title}</p>
                        <p className="manrope f-16 w-400 lh-24 black-085 text-center">{benefit.desc}</p>
                    </Col>

                ))}
            </Row>
        </Content>
    );
}



export default ALL3DBenefits;
